module.exports = __webpack_public_path__ + "static/2-2-5-e2893ae4ada44cf01b27ae83a8f67487.png";